import { createAction, props } from '@ngrx/store';

import { ApplicationStep, Proposal } from '@lockton-apps/shared/interfaces';

export enum ProposalHomeActionTypes {
  BeginProposal = '[Proposals Home] Begin Proposal',
  ContinueProposal = '[Proposals Home] Continue Proposal',
  StepsRebuilt = '[Proposals Home] Steps Rebuilt',
}

export const ProposalHomeActions = {
  beginProposal: createAction(
    ProposalHomeActionTypes.BeginProposal,
    props<{ proposal: Proposal }>()
  ),
  continueProposal: createAction(ProposalHomeActionTypes.ContinueProposal),
  stepsRebuilt: createAction(
    ProposalHomeActionTypes.StepsRebuilt,
    props<{ proposalId: string; steps: ApplicationStep[] }>()
  ),
};
